import { createSelector } from "@reduxjs/toolkit";

import { REQUEST_STATUSES } from "@/constants/index.js";
import type { Flags } from "@/store/types.js";

interface State {
  flags: {
    err: Error | null;
    flags: Flags;
    status: REQUEST_STATUSES;
  };
}

const initialState: State["flags"] = {
  err: null,
  flags: {},
  status: REQUEST_STATUSES.IDLE,
};

export const flagsSelector = createSelector(
  (state: State) => state.flags,
  (flags) => {
    return {
      ...initialState,
      ...flags,
    };
  },
);
